import { render, staticRenderFns } from "./usefull-links-detail.vue?vue&type=template&id=56352305&scoped=true&"
import script from "./usefull-links-detail.vue?vue&type=script&lang=js&"
export * from "./usefull-links-detail.vue?vue&type=script&lang=js&"
import style0 from "./usefull-links-detail.vue?vue&type=style&index=0&id=56352305&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56352305",
  null
  
)

export default component.exports